import React from "react";
import { bool, elementType, number, object, oneOf, shape, string } from "prop-types";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Button from "@insightfulscience/atomic-react/Button";
import Template from "../Template";
import CopyBlockContent from "./Content";

const CopyBlock = ({
	id,
	blockTitle,
	blockSubtitle,
	text: { content = [] },
	numberOfColumns,
	numberOfQuestions = 1,
	ctaLink,
	ctaText,
	ctaStyleType = "secondary",
	backgroundColor,
	alignment = "Left",
	internalSlug,
	faqCopy = false,
	components,
}) => {
	const borderStyles = !faqCopy ? { border: { left: { width: 1, color: "black--20" } } } : {};
	const containerProps = numberOfColumns === 1 ? { lg: 9, center: true } : {};
	const numberOfBlocks = faqCopy ? numberOfQuestions : 1;

	const colUtilityProps = { lg: { ...borderStyles } };
	const colSxProps = { textAlign: alignment === "Center" ? "center" : "left" };
	const colSpacingProps = {
		md: { px: 3 },
		...(numberOfBlocks > 1 ? { my: 8, sm: { my: 0 } } : { mb: 8, mt: 0, sm: { mb: 8 } }),
	};

	const SectionTemplate = components?.sectionTemplate || Template;
	return (
		<SectionTemplate
			title={blockTitle}
			subtitle={blockSubtitle}
			backgroundColor={backgroundColor}
			anchor={internalSlug}
			containerProps={containerProps}
		>
			<CopyBlockContent
				id={id}
				numberOfColumns={numberOfColumns}
				numberOfBlocks={numberOfBlocks}
				content={content}
				colUtilityProps={colUtilityProps}
				colSxProps={colSxProps}
				colSpacingProps={colSpacingProps}
			/>
			{ctaLink && ctaText && (
				<Row spacing={{ mt: 10 }}>
					<Col center>
						<Button.Link href={ctaLink} styleType={ctaStyleType} size="s" isPreLine>
							{ctaText}
						</Button.Link>
					</Col>
				</Row>
			)}
		</SectionTemplate>
	);
};

CopyBlock.propTypes = {
	internalSlug: string.isRequired,
	id: string,
	alignment: oneOf(["Left", "Center"]),
	text: object, // eslint-disable-line react/forbid-prop-types
	blockTitle: string,
	blockSubtitle: string,
	numberOfColumns: number,
	numberOfQuestions: number,
	backgroundColor: string,
	ctaStyleType: string,
	ctaText: string,
	ctaLink: string,
	faqCopy: bool,
	components: shape({
		sectionTemplate: elementType,
	}),
};

export default CopyBlock;
